import React, { Component } from 'react'
import { connect } from 'react-redux';
import {openModal} from '../modals/modalActions';
import {Button,Icon} from 'semantic-ui-react';
import GoogleMapReact from 'google-map-react';
import { incrementAsync, decrementAsync,incrementCounter, decrementCounter } from './testActions';

const Marker = () => <Icon name='marker' size='big' color='red'/>

 class TestComponent extends Component {
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33
    },
    zoom: 11
  };
     
  render() {
    const {incrementCounter, decrementCounter, incrementAsync, decrementAsync, loading, openModal, data} = this.props
    return (
      <div>
       <div>The answer is {data}</div> <br/>
        <Button onClick={incrementCounter} color="green" content="Increment" />
        <Button onClick={decrementCounter} color="red" content="Decrement" />
        <hr/>
        <Button loading={loading} onClick={incrementAsync} color="green" content="IncrementAsync" />
        <Button loading={loading} onClick={decrementAsync} color="red" content="DecrementAsync" />

        <Button content="Open Modal" onClick={() => openModal('TestModal',{data:43})} color='teal'/>
        <div style={{ height: '300px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: '' }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Marker
            lat={59.955413}
            lng={30.337844}
            text="My Marker"
          />
        </GoogleMapReact>
      </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
    data: state.test.data,
    loading: state.test.loading
})


const actions = {
  incrementCounter,
  decrementCounter,
  incrementAsync,
  decrementAsync,
  openModal
}

export default connect(mapStateToProps, actions)(TestComponent);


// WEBPACK FOOTER //
// ./src/features/testarea/TestComponent.jsx